// extracted by mini-css-extract-plugin
module.exports = {"conatiner":"_38OvJ","carousel-container":"_32bMD","carouselContainer":"_32bMD","carousel":"_2zxnO"};